import React, { useState, useEffect } from 'react';

const API_URL = process.env.REACT_APP_API_URL || '';
const getToken = () => localStorage.getItem('notes_token') || '';

async function fetchWithAuth(url, options = {}) {
  const token = getToken();
  const res = await fetch(`${API_URL}${url}`, { ...options, headers: { ...(options.headers || {}), 'x-token': token } });
  if (res.status === 401) { localStorage.removeItem('notes_token'); localStorage.removeItem('notes_user'); alert('登录超时，请重新登录'); window.location.href = '/'; return null; }
  return res;
}

export default function UserManager() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editingUser, setEditingUser] = useState(null);
  const [editForm, setEditForm] = useState({ realname: '', feishu_webhook: '' });

  const toggleDisable = async (user) => {
    const action = user.disabled ? '启用' : '停用';
    if (!window.confirm(`确定要${action}用户 "${user.realname || user.username}" 吗？\n${user.disabled ? '' : '停用后将删除该用户的所有周期任务'}`)) return;
    const res = await fetchWithAuth(`/api/admin/users/${user.username}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ disabled: !user.disabled })
    });
    if (!res) return;
    const data = await res.json();
    if (data.success) {
      fetchUsers();
    } else {
      alert('操作失败: ' + (data.error || '未知错误'));
    }
  };

  useEffect(() => { fetchUsers(); }, []);

  const fetchUsers = async () => {
    setLoading(true);
    const res = await fetchWithAuth('/api/admin/users');
    if (!res) return;
    const data = await res.json();
    if (data.success) setUsers(data.users);
    setLoading(false);
  };

  const startEdit = (user) => {
    setEditingUser(user.username);
    setEditForm({ realname: user.realname || '', feishu_webhook: user.feishu_webhook || '' });
  };

  const saveEdit = async () => {
    const res = await fetchWithAuth(`/api/admin/users/${editingUser}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(editForm)
    });
    if (!res) return;
    const data = await res.json();
    if (data.success) {
      setEditingUser(null);
      fetchUsers();
    } else {
      alert('保存失败: ' + (data.error || '未知错误'));
    }
  };

  if (loading) return <div className="loading-state">加载中...</div>;

  return (
    <div className="page-container">
      <h2 style={{ marginBottom: 24 }}>👥 用户管理</h2>
      
      <table style={{ width: '100%', borderCollapse: 'collapse', background: '#fff', borderRadius: 8 }}>
        <thead>
          <tr style={{ background: '#fafafa' }}>
            <th style={{ padding: 12, borderBottom: '1px solid #e8e8e8', textAlign: 'left' }}>账号</th>
            <th style={{ padding: 12, borderBottom: '1px solid #e8e8e8', textAlign: 'left' }}>姓名</th>
            <th style={{ padding: 12, borderBottom: '1px solid #e8e8e8', textAlign: 'left' }}>飞书Webhook</th>
            <th style={{ padding: 12, borderBottom: '1px solid #e8e8e8', textAlign: 'center' }}>状态</th>
            <th style={{ padding: 12, borderBottom: '1px solid #e8e8e8', textAlign: 'left' }}>创建时间</th>
            <th style={{ padding: 12, borderBottom: '1px solid #e8e8e8', textAlign: 'center' }}>操作</th>
          </tr>
        </thead>
        <tbody>
          {users.map(user => (
            <tr key={user.username}>
              <td style={{ padding: 12, borderBottom: '1px solid #f0f0f0' }}>{user.username}</td>
              <td style={{ padding: 12, borderBottom: '1px solid #f0f0f0' }}>
                {editingUser === user.username ? (
                  <input value={editForm.realname} onChange={e => setEditForm({ ...editForm, realname: e.target.value })} style={{ width: '100%', padding: 6, borderRadius: 4, border: '1px solid #d9d9d9' }} />
                ) : user.realname || '-'}
              </td>
              <td style={{ padding: 12, borderBottom: '1px solid #f0f0f0' }}>
                {editingUser === user.username ? (
                  <input value={editForm.feishu_webhook} onChange={e => setEditForm({ ...editForm, feishu_webhook: e.target.value })} style={{ width: '100%', padding: 6, borderRadius: 4, border: '1px solid #d9d9d9' }} placeholder="流程触发器webhook地址" />
                ) : (
                  <span style={{ color: user.feishu_webhook ? '#52c41a' : '#999', fontSize: 12 }}>
                    {user.feishu_webhook ? '✅ 已配置' : '❌ 未配置'}
                  </span>
                )}
              </td>
              <td style={{ padding: 12, borderBottom: '1px solid #f0f0f0', textAlign: 'center' }}>
                <span style={{ padding: '2px 8px', borderRadius: 4, background: user.disabled ? '#fff2f0' : '#f6ffed', color: user.disabled ? '#ff4d4f' : '#52c41a', fontSize: 12 }}>
                  {user.disabled ? '已停用' : '正常'}
                </span>
              </td>
              <td style={{ padding: 12, borderBottom: '1px solid #f0f0f0', fontSize: 12, color: '#666' }}>
                {user.created_at ? new Date(user.created_at).toLocaleDateString('zh-CN') : '-'}
              </td>
              <td style={{ padding: 12, borderBottom: '1px solid #f0f0f0', textAlign: 'center' }}>
                {editingUser === user.username ? (
                  <div style={{ display: 'flex', gap: 8, justifyContent: 'center' }}>
                    <button onClick={saveEdit} style={{ padding: '4px 12px', background: '#52c41a', color: '#fff', border: 'none', borderRadius: 4, cursor: 'pointer' }}>保存</button>
                    <button onClick={() => setEditingUser(null)} style={{ padding: '4px 12px', background: '#f0f0f0', border: '1px solid #d9d9d9', borderRadius: 4, cursor: 'pointer' }}>取消</button>
                  </div>
                ) : (
                  <div style={{ display: 'flex', gap: 8, justifyContent: 'center' }}>
                    <button onClick={() => startEdit(user)} style={{ padding: '4px 12px', background: '#1890ff', color: '#fff', border: 'none', borderRadius: 4, cursor: 'pointer' }}>编辑</button>
                    {user.username !== 'jch' && (
                      <button onClick={() => toggleDisable(user)} style={{ padding: '4px 12px', background: user.disabled ? '#52c41a' : '#ff4d4f', color: '#fff', border: 'none', borderRadius: 4, cursor: 'pointer' }}>
                        {user.disabled ? '启用' : '停用'}
                      </button>
                    )}
                  </div>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      
      <div style={{ marginTop: 16, padding: 12, background: '#fff7e6', borderRadius: 8, border: '1px solid #ffd591' }}>
        <p style={{ margin: 0, fontSize: 13, color: '#ad6800' }}>💡 飞书Webhook用于任务预警推送。需在飞书创建流程触发器并配置消息模板。</p>
      </div>
    </div>
  );
}